<style src="../assets/css/sponsor.css" scoped></style>


<template>

<main class="container">
  <!-- HERO -->
  <section class="hero">
    <div>
      <h1>Sponsors</h1>
      <p class="lead">
        Asso-Refuge est un projet <span class="hl">gratuit pour les refuges</span>
        (hébergement inclus, sans publicité).
        Les marques partenaires permettent de <span class="hl">financer l’infrastructure</span>,
        le développement et l’amélioration continue de la plateforme.
      </p>
    </div>

    <aside class="heroCard">
      <div class="label"><span class="dot"></span> Partenaires engagés</div>
      <p>
        En devenant sponsor, vous associez votre marque à un projet
        <span class="hl">utile</span>, <span class="hl">transparent</span>
        et à <span class="hl">impact réel</span> pour les refuges et l’adoption.
      </p>
      <div class="ctaRow">
        <a class="linkBtn primary" href="#">Devenir sponsor</a>
        <a class="linkBtn" href="#">Nous contacter</a>
      </div>
    </aside>
  </section>

  <!-- LISTE SPONSORS -->
  <section class="section">
    <h2>Nos sponsors</h2>

    <div class="grid">
      <article class="sponsorCard">
        <div class="logo">
          <span class="tier">Sponsor principal</span>
          <div class="mark"></div>
        </div>
        <div class="sponsorContent">
          <div class="sponsorName">Marque A</div>
          <div class="sponsorDesc">Soutien principal à l’infrastructure et à l’hébergement.</div>
          <div class="sponsorActions">
            <a class="primary" href="#">Découvrir</a>
            <a href="#">Site web</a>
          </div>
        </div>
      </article>

      <article class="sponsorCard">
        <div class="logo">
          <div class="mark"></div>
        </div>
        <div class="sponsorContent">
          <div class="sponsorName">Marque B</div>
          <div class="sponsorDesc">Financement des évolutions produit et du référencement.</div>
          <div class="sponsorActions">
            <a class="primary" href="#">Découvrir</a>
            <a href="#">Site web</a>
          </div>
        </div>
      </article>

      <article class="sponsorCard">
        <div class="logo">
          <div class="mark"></div>
        </div>
        <div class="sponsorContent">
          <div class="sponsorName">Marque C</div>
          <div class="sponsorDesc">Soutien aux outils mis à disposition des refuges.</div>
          <div class="sponsorActions">
            <a class="primary" href="#">Découvrir</a>
            <a href="#">Site web</a>
          </div>
        </div>
      </article>

      <article class="sponsorCard">
        <div class="logo">
          <div class="mark"></div>
        </div>
        <div class="sponsorContent">
          <div class="sponsorName">Marque D</div>
          <div class="sponsorDesc">Partenaire engagé pour la visibilité des animaux.</div>
          <div class="sponsorActions">
            <a class="primary" href="#">Découvrir</a>
            <a href="#">Site web</a>
          </div>
        </div>
      </article>
    </div>
  </section>

  <!-- CTA FINAL -->
  <section class="bigCta">
    <h3>Votre marque souhaite soutenir le projet ?</h3>
    <p>
      En devenant sponsor, vous contribuez à rendre l’adoption plus accessible,
      tout en associant votre image à une initiative <span class="hl">concrète</span> et
      <span class="hl">mesurable</span>.
    </p>
    <div class="ctaRow">
      <a class="linkBtn primary" href="#">Devenir sponsor</a>
      <a class="linkBtn" href="#">Nous contacter</a>
    </div>
  </section>
</main>

</template>